<template>
  <div class="wg-row" style="position: relative; height: calc(100vh - 60px)">
    <!-- Modale per la selezione dell'azienda -->
    <wg-modal
      v-if="showWorkDialog || (!workLoading && workSelected == 'my')"
      @closeModal="showWorkDialog = false"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "Work", "Azienda") }}
        </div>
      </div>
      <div slot="body" style="min-width:250px;width:100%;max-width:400px">
        <div
          ref="works_div"
          class="wg-row wg-xs-12 com-anm22-app-custom-scroll select-works-list"
          style="
            overflow-x: none;
            overflow-y: auto;
            padding: 5px;
            align-items: center;
            position: relative;
          "
        >
          <div v-if="workFilters.length == 0">
            {{
              $anm22.strLang(
                lang,
                "No BeTasker account active.",
                "Nessuna licenza BeTasker attiva."
              )
            }}<br />
            <br />
            {{
              $anm22.strLang(
                lang,
                "Write to info@anm22.it to buy it.",
                "Scrivi a info@anm22.it per acquistarne una."
              )
            }}
          </div>
          <div
            v-for="(workFilter, index) in workFilters"
            :key="'wf-' + index"
            :style="workFilter == workSelected ? 'background-color:#eee' : ''"
            @click="changeWork(workFilter)"
            class="item"
          >
            <div
              class="my-project-icon"
              style="cursor: pointer; min-width: 35px; padding: 0; display:inline-block;"
            >
              <world-object-icon
                :type="workFilter === 'my' ? 'user' : 'work'"
                :obj="
                  workFilter === 'my'
                    ? user
                    : $store.getters['works/get'](workFilter)
                "
                :isImg="workFilter === 'my' ? false : true"
                :customTitle="
                  workFilter === 'my'
                    ? $anm22.strLang(lang, 'My projects', 'I miei progetti')
                    : ''
                "
                :clickFn="() => changeWork(workFilter)"
              ></world-object-icon>
            </div>
            <div class="lbl">
              {{
                workFilter === "my"
                  ? $anm22.strLang(lang, "My projects", "I miei progetti")
                  : $store.getters["works/get"](workFilter).name
              }}
            </div>
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- Modale per la scelta della visualizzazione -->
    <wg-modal v-if="showViewDialog" @closeModal="showViewDialog = false">
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "View", "Visualizzazione") }}
        </div>
      </div>
      <div slot="body" class="views-list">
        <div
          v-for="(v, index) in boardsList"
          :key="'view-btn-' + index"
          :class="['item', selectedBoard.id == v.id ? 'selected' : '']"
          @click="changeView(v.id)"
        >
          <img :src="v.icon" />
          <div>{{ v.label }}</div>
        </div>
      </div>
    </wg-modal>
    <!-- Modale ordinamento -->
    <wg-modal
      :width="windowWidth > 700 ? '300px' : '80%'"
      v-if="changeOrder"
      @closeModal="changeOrder = false"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "Order", "Ordinamento") }}
        </div>
      </div>
      <div slot="body">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Order by", "Ordina per") }}
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <select
          class="com-anm22-app-select"
          v-model="orderingField"
          @change="changeFieldSorting()"
        >
          <option
            v-for="(f, index) in orderingFields"
            :class="[
              f.field == 'status' && f.field != orderingField ? 'none' : '',
            ]"
            :disabled="f.field == 'status'"
            :key="'field-' + index"
            :value="f.field"
          >
            {{ f.label }}
          </option>
        </select>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Direction", "Direzione") }}
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <select
          @change="changeDirectionSorting()"
          class="com-anm22-app-select"
          v-model="orderingDir"
        >
          <option value="DESC">
            {{ $anm22.strLang(lang, "Decreasing", "Decrescente") }}
          </option>
          <option value="ASC">
            {{ $anm22.strLang(lang, "Increasing", "Crescente") }}
          </option>
        </select>
      </div>
    </wg-modal>
    <template v-if="!loading">
      <anm22-dialog-filter
        v-if="showFilterDialog"
        :allFilters="projectFilters"
        :activeGuide="true"
        :selected="selectedFilters"
        @applyFilters="filterProjects($event)"
        @closeFilter="showFilterDialog = false"
        @showHelpDialog="showHelpDialog"
      ></anm22-dialog-filter>
      <!-- Creazione nuovo progetto, scelta modalità -->
      <wg-modal
        v-if="showAddDialog"
        :width="windowWidth > 700 ? '700px' : '90%'"
        :portal="true"
        @closeModal="
          showAddDialog = !showAddDialog;
          customerId = null;
          customerWork = null;
        "
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{
            $anm22.strLang(lang, "Create new project", "Crea nuovo progetto")
          }}
        </div>
        <project-add-modal
          slot="body"
          :customerId="customerId"
          :work="customerWork != null ? customerWork : workSelected"
        ></project-add-modal>
      </wg-modal>
      <!-- Dialog per la gestione dei template di progetto -->
      <wg-modal
        v-if="showTemplatesDialog"
        :width="windowWidth > 700 ? '700px' : '90%'"
        :portal="true"
        @closeModal="showTemplatesDialog = !showTemplatesDialog"
      >
        <div class="display-flex com-anm22-app-text-xl" slot="header">
          {{
            $anm22.strLang(lang, "Project templates", "Template di progetto")
          }}
          <div class="com-anm22-app-horizontal-space" style="width: 5px"></div>
        </div>
        <!-- Lista progetti template -->
        <div slot="body">
          <project-templates
            :projectsData="templatesData"
            :sortingFunctionGenerator="sortingFunctionGenerator"
          ></project-templates>
          <div style="position: relative; float: right">
            <img
              @click="showHelpTemplate = !showHelpTemplate"
              class="com-anm22-app-img-s"
              style="opacity: 0.6; cursor: pointer"
              :src="$anm22.icons.getWorldIcon('helpIcon')"
            />
            <world-help-label
              v-if="showHelpTemplate"
              @closeLabel="showHelpTemplate = false"
              :position="'up-left'"
              :text="
                'Aggiungi o modifica i dati di un template progetto. Note: questa sezione è visibile solo agli utenti con permesso manager'
              "
            ></world-help-label>
          </div>
          <div style="clear: both; margin-top: 20px">
            {{
              $anm22.strLang(
                lang,
                "The button to open the template list will be moved to the menu with the list of project boards.",
                "Il pulsante per aprire la lista dei template sarà spostato nel menu con l'elenco delle board dei progetti."
              )
            }}
          </div>
        </div>
      </wg-modal>
      <div
        v-if="boardsMenuOpen"
        class="wg-col wg-xs-12 wg-md-3 wg-lg-2 wg-xl-1 no-print"
        style="padding:0 10px"
      >
        <nav class="wg-row sub-menu-nav">
          <img
            class="sub-menu-close-btn desktop"
            :src="$anm22.icons.getWorldIcon('arrowLeft')"
            @click="closeBoardsMenu()"
          />
          <img
            class="sub-menu-close-btn mobile"
            :src="$anm22.icons.getWorldIcon('deleteBlack')"
            @click="closeBoardsMenu()"
          />
          <ul class="sub-menu-ul">
            <li class="wg-row sub-menu-li main-title not-clickable">
              <div class="com-anm22-app-text-l">
                {{ $anm22.strLang(lang, "Projects boards", "Board progetti") }}
              </div>
            </li>
            <li
              class="wg-row sub-menu-li text not-clickable"
              style="padding:0 0 10px 0"
            >
              <div class="com-anm22-app-text-md" style="font-weight:400">
                {{
                  $anm22.strLang(
                    lang,
                    "Select the desired board or view.",
                    "Seleziona la dashboard o la visualizzazione desiderata."
                  )
                }}
              </div>
            </li>
            <li
              v-for="(v, index) in boardsList"
              :key="'view-btn-' + index"
              :class="[
                'wg-row sub-menu-li',
                selectedBoard.id == v.id ? 'selected' : '',
              ]"
              @click="changeView(v.id)"
            >
              <img class="item-icon" :src="v.icon" />
              <div class="com-anm22-app-text-m">{{ v.label }}</div>
            </li>
            <div class="menu-divider"></div>
            <li class="wg-row sub-menu-li disabled">
              <img class="item-icon" :src="$anm22.icons.getWorldIcon('add')" />
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Add dashboard", "Nuova dashboard") }}
              </div>
            </li>
            <template v-if="userPermission <= 3 && workSelected != 474">
              <div class="menu-divider"></div>
              <li
                class="wg-row sub-menu-li"
                @click="showTemplatesDialog = true"
              >
                <img
                  class="item-icon"
                  :src="$anm22.icons.getWorldIcon('menu')"
                />
                <div class="com-anm22-app-text-m">
                  {{ $anm22.strLang(lang, "Templates", "Template") }}
                </div>
              </li>
            </template>
            <div class="menu-divider"></div>
            <li class="wg-row sub-menu-li" @click="closeBoardsMenu()">
              <img
                class="item-icon"
                :src="$anm22.icons.getWorldIcon('arrowLeft')"
              />
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Collapse menu", "Chiudi menu") }}
              </div>
            </li>
          </ul>
        </nav>
      </div>
      <div
        :class="
          boardsMenuOpen
            ? 'wg-col wg-xs-none wg-md-9 wg-lg-10 wg-xl-11 projects-view-body'
            : 'wg-col wg-xs-12 projects-view-body'
        "
        style="padding: 10px 10px 0 10px;"
      >
        <!-- VISUALIZZAZIONE DATI AZIENDA / MIO PROFILO -->
        <div
          class="wg-row"
          style="flex-wrap: nowrap; align-items: center; padding: 5px"
        >
          <div
            class="my-project-icon"
            style="cursor: pointer; min-width: 35px; padding: 0; margin-right: 8px;"
            @click="showWorkDialog = true"
          >
            <world-object-icon
              :type="workSelected === 'my' ? 'user' : 'work'"
              :obj="
                workSelected === 'my'
                  ? user
                  : $store.getters['works/get'](workSelected)
              "
              :customTitle="
                workSelected === 'my'
                  ? $anm22.strLang(lang, 'My projects', 'I miei progetti')
                  : ''
              "
              :isImg="workSelected === 'my' ? false : true"
            ></world-object-icon>
          </div>
          <div
            class="com-anm22-app-text-xxl"
            style="cursor:pointer"
            @click="changeBoardsMenuStatus()"
          >
            {{ title }}
          </div>
          <div
            class="open-board-menu-btn"
            v-if="!boardsMenuOpen"
            @click="openBoardsMenu()"
          >
            <img
              :src="$anm22.icons.getWorldIcon('arrowDown')"
              class="com-anm22-app-img-s img"
            />
            <div class="open-board-menu-btn-label">
              {{
                $anm22.strLang(lang, "Change board", "Cambia visualizzazione")
              }}
            </div>
          </div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <!-- Nuovo progetto - aggiungere gestione permessi -->
        <div class="wg-row wg-xs-12 wg-p-xs-10" style="align-items: center">
          <template v-if="canAdd && windowWidth > 767">
            <div class="display-flex" style="margin-right: 10px">
              <input
                type="button"
                class="small"
                :value="
                  $anm22.strLang(lang, '+ New project', '+ Nuovo progetto')
                "
                @click="showAddDialog = true"
              />
            </div>
          </template>
          <template v-if="userPermission <= 3 && workSelected != 474">
            <div class="display-flex" style="margin-right: 10px">
              <input
                type="button"
                class="small"
                :value="$anm22.strLang(lang, 'Templates', 'Template')"
                @click="showTemplatesDialog = true"
              />
            </div>
          </template>
          <div
            class="display-flex"
            style="flex-wrap: nowrap; align-items: center"
          >
            <input
              type="button"
              class="small filter-button"
              :style="{
                backgroundImage:
                  'url(' + $anm22.icons.getWorldIcon('filterList') + ')',
                paddingLeft: windowWidth > 767 ? '32px' : '28px',
              }"
              :value="
                windowWidth > 767
                  ? $anm22.strLang(lang, 'Filters', 'Filtri')
                  : ''
              "
              @click="showFilterDialog = true"
            />
            <!-- Icone filtri correntemente attivati -->
            <img
              v-for="(f, i) in selectedFilters
                .map((f) => this.projectFilters.find((pf) => pf.id === f.id))
                .filter((f) => f && getFilterIcon(f))"
              :key="'sel-filter-' + i"
              :src="$anm22.icons.getWorldIcon(getFilterIcon(f))"
              :title="f.label"
              class="com-anm22-app-img-fixed-height-m com-anm22-round"
              style="
                width: 30px;
                height: 30px;
                padding: 5px;
                margin-left: 10px;
                background-color: #ddd;
              "
            />
          </div>
          <div v-if="windowWidth > 767" style="margin-left: auto">
            <anm22-searchbar-filter
              :eventName="'project-filter'"
              :filters="searchFilters"
              @filtersUpdate="filterSearchedProjects($event)"
            ></anm22-searchbar-filter>
          </div>
          <div v-if="view == 'cols'" style="padding: 5px">
            <input
              type="button"
              class="small"
              :value="
                $anm22.strLang(lang, 'Change order', 'Cambia ordinamento')
              "
              @click="changeOrder = true"
            />
          </div>
        </div>
        <template v-if="windowWidth < 768">
          <anm22-searchbar-filter
            style="margin-top: 10px"
            :eventName="'project-filter'"
            :filters="searchFilters"
            @filtersUpdate="filterSearchedProjects($event)"
          ></anm22-searchbar-filter>
        </template>
        <!-- Lista progetti -->
        <div
          v-if="allProjects.length === 0 && !loading"
          class="com-anm22-app-text-xl"
        >
          <img
            :src="$anm22.icons.getWorldIcon('menuTasks')"
            style="width: 200px; display: block; margin: 20px auto; opacity: 0.1"
          />
          <div
            style="
              text-align: center;
              max-width: 400px;
              font-size: 16px;
              color: #666;
              margin: 0 auto;
            "
          >
            {{ $anm22.strLang(lang, "No projects", "Nessun progetto") }}
          </div>
          <div
            style="
              text-align: center;
              max-width: 400px;
              font-size: 14px;
              color: #999;
              margin: 0 auto 50px auto;
            "
          >
            {{
              $anm22.strLang(
                lang,
                "Create a new project or change selected filters and company",
                "Crea un nuovo progetto o cambia i filtri e l'azienda selezionati."
              )
            }}
          </div>
        </div>
        <template v-else>
          <projects-kanban
            v-if="view === 'cols'"
            :projectsData="allProjectsData.filter((pd) => !pd.template)"
            :sortingFunctionGenerator="sortingFunctionGenerator"
            :separateUrgent="separateUrgent"
            :orderingField="orderingField"
            :orderingDir="orderingDir"
          ></projects-kanban>
          <projects-gantt
            v-else-if="view === 'gantt'"
            :workSelected="workSelected"
            :projectsData="allProjectsData.filter((pd) => !pd.template)"
          ></projects-gantt>
          <projects-timeline
            v-else-if="view === 'timeline'"
            :workSelected="workSelected"
            :projectsData="allProjectsData.filter((pd) => !pd.template)"
          ></projects-timeline>
          <projects-jobs
            v-else-if="view === 'jobs'"
            :projectsData="allProjectsData.filter((pd) => !pd.template)"
            :customView="selectedCustomView"
            :sortingFunctionGenerator="sortingFunctionGenerator"
            :separateUrgent="separateUrgent"
            :orderingField="orderingField"
            :orderingDir="orderingDir"
          ></projects-jobs>
          <projects-custom-kanban
            v-else-if="view === 'customKanban'"
            :projectsData="allProjectsData.filter((pd) => !pd.template)"
            :customView="selectedCustomView"
            :sortingFunctionGenerator="sortingFunctionGenerator"
            :separateUrgent="separateUrgent"
            :orderingField="orderingField"
            :orderingDir="orderingDir"
          ></projects-custom-kanban>
          <projects-list
            v-else
            :projectsData="allProjectsData.filter((pd) => !pd.template)"
            :sortingFunctionGenerator="sortingFunctionGenerator"
          ></projects-list>
        </template>
        <!-- Legenda -->
        <div class="wg-row" style="padding: 10px">
          <div
            v-for="status in [6, 1, 2, 3, 4, 5].map((s) =>
              $anm22.tableClasses.projectStatus().getById(s)
            )"
            :key="'sl-' + status.typeClass"
            :style="
              'border-left:4px solid ' +
                borderColor(status.typeClass) +
                ';padding:2px 10px 2px 5px;font-size:12px;'
            "
          >
            {{ status[lang] }}
          </div>
        </div>
        <!-- Floating button per l'aggiunta -->
        <wg-fab
          v-if="canAdd"
          class="no-print"
          style="position: fixed; bottom: 30px; right: 30px; z-index: 20"
          :title="$anm22.strLang(lang, 'New project', 'Nuovo progetto')"
          :icon="$anm22.icons.getWorldIcon('addWhite')"
          :bgColor="'#88ed7c'"
          :click="() => (showAddDialog = true)"
        ></wg-fab>
      </div>
    </template>
    <div v-else class="wg-row" style="margin: 10px; justify-content: center">
      <vue-simple-spinner size="medium" line-fg-color="rgb(136, 237, 124)" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProjectsList from "../components/projects/ProjectsList.vue";
import ProjectsKanban from "../components/projects/ProjectsKanban.vue";
import ProjectsGantt from "../components/projects/ProjectsGantt.vue";
import ProjectsTimeline from "../components/projects/ProjectsTimeline.vue";
import ProjectsJobs from "../components/projects/ProjectsJobs.vue";
import ProjectsCustomKanban from "../components/projects/ProjectsCustomKanban.vue";
// import ProjectBar from "../components/project/ProjectBar.vue";
import ProjectAddModal from "../components/project/ProjectAddModal.vue";
import ProjectTemplates from "../components/project/ProjectTemplates.vue";
import WorldHelpLabel from "../../../../world/spa/components/WorldHelpLabel.vue";
import Spinner from "vue-simple-spinner";
import Anm22DialogFilter from "../../../../world/spa/components/Anm22DialogFilter.vue";
import Anm22SearchbarFilter from "../../../../world/spa/components/Anm22SearchbarFilter.vue";

export default {
  data() {
    return {
      loading: false,
      view:
        this.$anm22.getCookie("tk_p_view") !== ""
          ? this.$anm22.getCookie("tk_p_view").startsWith("custom-")
            ? "jobs"
            : this.$anm22.getCookie("tk_p_view")
          : "cols",
      workSelected: "my",
      workLoading: true,
      showWorkDialog: false,
      customerWork: null,
      customerId: null,
      defaultIcon: this.$anm22.icons.getWorldIcon("workDefault"),
      showAddDialog: false,
      boardsMenuOpen:
        this.$anm22.getCookie("tk_p_bmo") == "false" ? false : true,
      /* Filtraggio mediante impostazioni (con componente separato) */
      showFilterDialog: false,
      showHelpTemplate: false,
      selectedFilters: [
        // Default filtro sui progetti completati
        { id: "completed", value: 1 },
      ],
      /* Filtraggio mediante barra di ricerca */
      searchFilters: [],
      updateInterval: null,
      showTemplatesDialog: false,
      showViewDialog: false,
      changeOrder: false,
      orderingField:
        this.$anm22.getCookie("tk_p_col") !== ""
          ? this.$anm22.getCookie("tk_p_col")
          : "deadline",
      orderingDir:
        this.$anm22.getCookie("tk_p_dir") !== ""
          ? this.$anm22.getCookie("tk_p_dir")
          : "ASC",
      customViews: [
        {
          id: 1,
          work: 16,
          name: "Etichette",
          type: "jobs",
          jobs: ["labels", "labelprinting"],
          icon: this.$anm22.icons.getWorldIcon("tag"),
        },
        {
          id: 2,
          work: 16,
          name: "Spedizioni",
          type: "customKanban",
          cols: [
            {
              id: "finishing",
              name: "✨ Da finire",
              rules: function(projectData) {
                if (!projectData.deadline) {
                  return false;
                }
                const projectDeadlineDate = new Date(
                  projectData.deadline * 1000
                );
                const currentDate = new Date();
                const formatter = new Intl.DateTimeFormat("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // User's timezone
                });

                if (
                  formatter.format(projectDeadlineDate) !==
                  formatter.format(currentDate)
                ) {
                  return false;
                }
                return true;
              },
            },
            {
              id: "shipping",
              name: "🚚 Da spedire",
              rules: function(projectData) {
                if (
                  !projectData.shippingMode ||
                  projectData.shippingMode !== "shipping"
                ) {
                  return false;
                }
                if (!projectData.deadline) {
                  return false;
                }
                const projectDeadlineDate = new Date(
                  projectData.deadline * 1000
                );
                const currentDate = new Date();
                const formatter = new Intl.DateTimeFormat("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // User's timezone
                });

                if (
                  formatter.format(projectDeadlineDate) !==
                  formatter.format(currentDate)
                ) {
                  return false;
                }
                return true;
              },
            },
          ],
          icon: this.$anm22.icons.getWorldIcon("shippingTruck"),
        },
      ],
      selectedCustomView: {
        id: null,
        work: null,
        name: "",
        type: "jobs",
        jobs: [],
      },
      selectedBoard: {
        id: "cols",
        type: "cols",
        isCustom: false,
        customId: null,
        icon: this.$anm22.icons.getWorldIcon("viewFull"),
        label: this.$anm22.strLang(this.lang, "Kanban", "Kanban"),
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      // licenses: state => state.licenses.objs,
      windowWidth: (state) => state.windowWidth,
      offline: (state) => state.offline.isOffline,
    }),
    licenseByCustomerWork() {
      if (this.customerWork) {
        return [this.$store.getters["licenses/getByWork"](this.customerWork)];
      } else {
        return [];
      }
    },
    commercialPermissionByCustomerWork() {
      //Personalizzazione spiagge.it
      if (this.customerWork && this.customerWork == 6) {
        const e = this.$store.getters["employments/get"](
          this.user.idWorldUser + "-" + this.customerWork
        );
        if (e) {
          if (e.jobs.find((job) => job == "com")) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    userPermissionByCustomerWork() {
      return this.$store.getters["employments/getPermByWork"](
        this.customerWork
      );
    },
    customerManagerByCustomerWork() {
      if (this.customerWork && !this.loading) {
        const e = this.$store.getters["employments/get"](
          this.user.idWorldUser + "-" + this.customerWork
        );
        if (e && e.clients.reduce((res, c) => res || c.isManager, false)) {
          return true;
        }
      }
      return false;
    },
    canAddByCustomerWork() {
      const functions = this.licenseByCustomerWork.filter(
        (l) =>
          l &&
          l.config.tasks &&
          l.config.tasks.project &&
          l.config.tasks.project["add-rules"]
      );
      if (functions.length > 0) {
        return functions.reduce(
          (result, l) =>
            result && this.$anm22[l.config.tasks.project["add-rules"]](this),
          true
        );
      } else {
        return (
          this.userPermissionByCustomerWork <= 3 ||
          this.customerManagerByCustomerWork ||
          this.commercialPermissionByCustomerWork
        );
      }
    },
    licenses() {
      if (this.workSelected !== "my") {
        return [this.$store.getters["licenses/getByWork"](this.workSelected)];
      } else {
        // Mostro il pulsante se almeno uno dei miei employment mi permette di creare progetti
        return this.$store.getters["employments/getByUser"](
          this.user.idWorldUser
        )
          .map((e) => this.$store.getters["licenses/getByWork"](e.work))
          .filter((l) => l);
      }
    },
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.workSelected
      );
    },
    customerManager() {
      if (this.workSelected !== "my" && !this.loading) {
        const e = this.$store.getters["employments/get"](
          this.user.idWorldUser + "-" + this.workSelected
        );
        if (e && e.clients.reduce((res, c) => res || c.isManager, false)) {
          return true;
        }
      }
      return false;
    },
    canAdd() {
      const functions = this.licenses.filter(
        (l) =>
          l &&
          l.config.tasks &&
          l.config.tasks.project &&
          l.config.tasks.project["add-rules"]
      );
      if (functions.length > 0) {
        return functions.reduce(
          (result, l) =>
            result && this.$anm22[l.config.tasks.project["add-rules"]](this),
          true
        );
      } else {
        return this.userPermission <= 3 || this.customerManager;
      }
    },
    title() {
      return this.selectedBoard.label;
    },
    workFilters() {
      return [
        ...this.$store.getters["employments/getByUser"](
          this.user.idWorldUser
        ).map((e) => e.work),
      ];
    },
    templatesData() {
      return this.$store.getters["projects/getAllByWork"](this.workSelected)
        .filter((p) => p.template)
        .map((p) => {
          const data = {
            id: p.idWorldProject,
            projectId: p.projectId,
            template: p.template,
            name: p.name,
            users: p.users,
            status: p.status,
            jobs: p.jobs,
            developers: p.developers,
            urgent: p.urgent,
            startDate: p.startDate,
            endDate: p.endDate,
            deadline: p.deadline,
          };
          // Build codeName
          let codeName = "";
          codeName += p.projectId || "";
          codeName += p.projectId && p.name ? " - " : "";
          codeName += p.name || "";
          data.codeName = codeName;
          return data;
        });
    },
    allProjects() {
      return this.$store.getters["projects/getAllByWork"](
        this.workSelected
      ).filter(
        (p) =>
          !p.template &&
          !p.deleted &&
          this.selectedFilters.reduce((result, selectedFilter) => {
            const filter = this.projectFilters.find(
              (f) => f.id === selectedFilter.id
            );
            // Check if this work offers this filter
            if (filter) {
              return result && filter.apply(p, selectedFilter.value);
            } else {
              return result;
            }
          }, true) &&
          this.searchFilters.reduce((result, f) => {
            return result && this.filterMethod(f.fn, p);
          }, true)
      );
    },
    allProjectsData() {
      return this.allProjects.map((p) => {
        const data = {
          id: p.idWorldProject,
          projectId: p.projectId,
          template: p.template,
          name: p.name,
          users: p.users,
          jobs: p.jobs,
          developers: p.developers,
          status: p.status,
          urgent: p.urgent,
          startDate: p.startDate,
          endDate: p.endDate,
          deadline: p.deadline,
          description: p.description,
          tags: p.tags,
          priorityScore: p.priorityScore,
          jobs: p.jobs,
          shippingMode: p.shippingMode,
        };
        // Build codeName
        let codeName = "";
        codeName += p.projectId || "";
        codeName += p.projectId && p.name ? " - " : "";
        codeName += p.name || "";
        data.codeName = codeName;
        if (p.status < 4) {
          const jobFilter = this.selectedFilters.find((f) => f.id === "job");
          // My status
          if (this.selectedFilters.find((f) => f.id === "personal")) {
            data.status = p.personal.status;
          } else if (
            this.projectFilters.find((f) => f.id === "job") &&
            jobFilter
          ) {
            if (jobFilter.value === "my") {
              data.status = Object.keys(p.jobs)
                .filter((j) => -1 !== this.myJobs.indexOf(j))
                .reduce((res, j) => Math.min(res, p.jobs[j].status), 3);
            } else {
              data.status = p.jobs[jobFilter.value].status;
            }
          }
        }
        return data;
      });
    },
    separateUrgent() {
      return this.licenses.reduce((res, l) => {
        return (
          res ||
          (l &&
            l.config &&
            l.config.tasks &&
            l.config.tasks.dashboard &&
            l.config.tasks.dashboard["separate-urgent"])
        );
      }, false);
    },
    projectCategories() {
      return this.$store.getters["projectCategories/getAll"];
    },
    myJobs() {
      return this.$store.getters["employments/getAll"].reduce(
        (result, employment) => result.concat(employment.jobs),
        []
      );
    },
    projectFilters() {
      const filters = [
        /* Progetti con Task assegnati a me */
        {
          id: "personal",
          label: this.$anm22.strLang(
            this.lang,
            "Only personal tasks",
            "Solo task personali"
          ),
          type: "checkbox",
          showHelp: false,
          guide: true,
          apply: (project) => {
            /**
             * Mostro soltanto i progetti con all'interno task assegnati a me
             */
            return project.tasksUsers.includes(this.user.idWorldUser);
          },
        },
        /* FS */
        {
          id: "fs",
          label: this.$anm22.strLang(this.lang, "Queue", "In coda"),
          type: "checkbox",
          showHelp: false,
          guide: true,
          apply: (project) => {
            /**
             * se è presente il filtro (non c'è alcun valore passato) vengono mostrati solo i progetti al cui interno
             * c'è almeno un task non completato per cui tutte le dipendenze FS sono soddisfatte
             */
            if (this.selectedFilters.find((f) => f.id === "personal")) {
              return project.personal.ready;
            } else {
              if (this.selectedFilters.find((f) => f.id === "job")) {
                const job = this.selectedFilters.find((f) => f.id === "job")
                  .value;
                if (job === "my") {
                  return Object.keys(project.jobs)
                    .filter((j) => -1 !== this.myJobs.indexOf(j))
                    .reduce((res, j) => res || project.jobs[j].ready, false);
                } else {
                  return project.jobs[job] ? project.jobs[job].ready : false;
                }
              } else {
                return project.ready;
              }
            }
          },
        },
        /* Progetti completati, fatturati o cancellati nell'anno in corso */
        {
          id: "completed",
          label: this.$anm22.strLang(
            this.lang,
            "Only projects completed this year",
            "Solo progetti completati nell'anno in corso"
          ),
          type: "checkbox",
          showHelp: false,
          guide: true,
          apply: (project) => {
            if (project.status > 2) {
              return this.$moment
                .unix(project.endDate)
                .isSameOrAfter(this.$moment(), "year");
            } else {
              return true;
            }
          },
        },
      ];
      /* Postazioni (Jobs) */
      const jobs =
        //Carico i jobs di licenza (tutte le licenze se ho selezionato 'my')
        this.licenses
          // filtro le licenze
          // .filter(l => this.workSelected === 'my' || l.work === this.workSelected)
          // Costruisco un unico array con tutti i job delle licenze selezionate
          .reduce(
            // Prima di richiedere i jobs, devo assicurarmi che sia presente la configurazione
            (acc, license) => {
              return acc.concat(
                license && license.config.tasks && license.config.tasks.jobs
                  ? license.config.tasks.jobs
                  : []
              );
            },
            []
          )
          // // Filtro eventuali jobs vuoti e soltanto quelli legati ai miei job / tutti se sono amministratore
          .filter((job) => {
            return (
              Object.keys(job).length > 0 &&
              (this.userPermission > 2
                ? -1 !== this.myJobs.indexOf(job.id)
                : true)
            );
          })
          // // Costruisco gli oggetti che utilizza anm22filter per la select
          .map((job) => {
            return {
              label: this.$anm22.strLang(this.lang, job.en, job.it),
              value: job.id,
            };
          });
      if (jobs && jobs.length > 0) {
        filters.push({
          id: "job",
          label: this.$anm22.strLang(this.lang, "Station", "Postazione"),
          type: "select",
          showHelp: false,
          guide: true,
          values: [
            {
              label: this.$anm22.strLang(
                this.lang,
                "My stations",
                "Mie postazioni"
              ),
              value: "my",
            },
            ...jobs,
          ],
          apply: (project, job) => {
            /**
             * La funzione controlla tutti i task del progetto per confrontare i jobs del task con quelli
             * per cui è abilitato l'utente o con la singola postazione selezionata
             */
            if (job === "my") {
              return (
                Object.keys(project.jobs).filter(
                  (j) => -1 !== this.myJobs.indexOf(j)
                ).length > 0
              );
            } else {
              return Object.keys(project.jobs).includes(job);
            }
          },
        });
      }
      const categories = this.projectCategories
        .filter(
          (pc) => this.workSelected === "my" || pc.work === this.workSelected
        )
        .map((pc) => {
          return {
            label: pc.name,
            value: pc.idWorldProjectCategory,
          };
        });
      if (categories && categories.length > 0) {
        filters.push({
          /* Categorie di progetto */
          id: "category",
          label: this.$anm22.strLang(this.lang, "Category", "Categoria"),
          type: "select",
          showHelp: false,
          guide: true,
          values: categories,
          apply: (project, value) => {
            return project.category == value;
          },
        });
      }
      return filters;
    },
    sortingFunctionGenerator() {
      if (this.workSelected !== "my") {
        const license = this.$store.getters["licenses/getByWork"](
          this.workSelected
        );
        if (
          license &&
          license.config &&
          license.config.tasks &&
          license.config.tasks.dashboard &&
          license.config.tasks.dashboard["sorting-function-generator"]
        ) {
          return this.$anm22[
            license.config.tasks.dashboard["sorting-function-generator"]
          ];
        }
      }
      return this.getDefaultSortingFunctionGenerator;
    },
    orderingFields() {
      return [
        {
          field: "smart",
          label: this.$anm22.strLang(this.lang, "Smart", "Smart"),
        },
        {
          field: "projectId",
          label: this.$anm22.strLang(this.lang, "Code", "Codice"),
        },
        {
          field: "name",
          label: this.$anm22.strLang(this.lang, "Name", "Nome"),
        },
        {
          field: "codeName",
          label: this.$anm22.strLang(this.lang, "CodeName", "Codice - Nome"),
        },
        {
          field: "status",
          label: this.$anm22.strLang(this.lang, "Status", "Stato"),
        },
        {
          field: "startDate",
          label: this.$anm22.strLang(this.lang, "Start", "Inizio"),
        },
        {
          field: "deadline",
          label: this.$anm22.strLang(this.lang, "Deadline", "Scadenza"),
        },
      ];
    },
    availableCustomViews() {
      return this.customViews.filter((v) => v.work == this.workSelected);
    },
    boardsList() {
      var boards = [
        {
          id: "full",
          type: "list",
          isCustom: false,
          customId: null,
          icon: this.$anm22.icons.getWorldIcon("viewFull"),
          label: this.$anm22.strLang(this.lang, "List", "Lista"),
        },
        {
          id: "cols",
          type: "cols",
          isCustom: false,
          customId: null,
          icon: this.$anm22.icons.getWorldIcon("viewCols"),
          label: "Kanban",
        },
        {
          id: "gantt",
          type: "gantt",
          isCustom: false,
          customId: null,
          icon: this.$anm22.icons.getWorldIcon("viewGantt"),
          label: this.$anm22.strLang(this.lang, "Users gantt", "Gantt utenti"),
        },
        {
          id: "timeline",
          type: "timeline",
          isCustom: false,
          customId: null,
          icon: this.$anm22.icons.getWorldIcon("viewGantt"),
          label: this.$anm22.strLang(this.lang, "Timeline", "Timeline"),
        },
      ];
      if (this.availableCustomViews) {
        var i, customView;
        for (i = 0; i < this.availableCustomViews.length; i++) {
          customView = this.availableCustomViews[i];
          boards.push({
            id: "custom-" + customView.id,
            type: customView.type,
            isCustom: true,
            customId: customView.id,
            icon: customView.icon,
            label: customView.name,
          });
        }
      }
      return boards;
    },
  },
  methods: {
    filterMethod(fn, p) {
      switch (fn.type) {
        case "user":
          return p.users.includes(fn.obj.idWorldUser);
        case "tag":
          return (
            p.tags.includes(fn.obj.idWorldTag) &&
            p.developers.includes(fn.obj.work)
          );
        case "name":
          return (
            p.name.toLowerCase().includes(fn.obj.toLowerCase()) ||
            p.description.toLowerCase().includes(fn.obj.toLowerCase())
          );
      }
    },
    searchFn(string) {
      const regexp = new RegExp(string, "i");
      let results = [];
      /* Ricerca contatti per nome */
      results = results.concat(
        this.allProjects
          .filter((p) => {
            return (
              -1 !== p.name.search(regexp) || -1 !== p.projectId.search(regexp)
            );
          })
          .map((p) => {
            const label =
              (p.projectId || "") +
              (p.projectId && p.name ? " - " : "") +
              (p.name || "");
            return {
              label: label,
              img: this.getIconByStatus(p.status),
              submitFn: () => {
                this.$router.push("/project/" + p.idWorldProject);
              },
            };
          })
      );
      results = results.concat(
        this.$store.getters["users/getAll"]
          .filter((u) => {
            const fullName = u.name + " " + u.surname;
            return -1 !== fullName.search(regexp);
          })
          .map((u) => {
            return {
              label: u.name + " " + u.surname,
              img: this.$anm22.icons.getWorldIcon("userDefault"),
              submitFn: () => {
                this.$anm22.eventBus.$emit("project-filter", {
                  name: u.name + " " + u.surname,
                  fn: { type: "user", obj: u },
                  //fn: p => p.users.includes(u.idWorldUser)
                });
              },
            };
          })
      );
      results = results.concat(
        this.$store.getters["tags/getAll"]
          .filter((tag) => {
            const tagName = tag.label;
            return -1 !== tagName.search(regexp);
          })
          .map((t) => {
            return {
              label: t.label,
              img: this.$anm22.icons.getWorldIcon("tag"),
              submitFn: () => {
                this.$anm22.eventBus.$emit("project-filter", {
                  name: t.label,
                  fn: { type: "tag", obj: t },
                  //fn: p => p.tags.includes(t.idWorldTag) && p.developers.includes(t.work)
                });
              },
            };
          })
      );
      results = results.concat([
        {
          label: string,
          img: this.$anm22.icons.getWorldIcon("searchLeft"),
          submitFn: () => {
            this.$anm22.eventBus.$emit("project-filter", {
              name: string,
              fn: { type: "name", obj: string },
            });
          },
        },
      ]);
      return results;
    },
    showHelpDialog(id) {
      let filter = this.projectFilters.find((f) => f.id === id);
      filter.showHelp = !filter.showHelp;
    },
    /* Utilizzato dalla legenda */
    borderColor(status) {
      switch (Number(status)) {
        case 1:
          return "#bdbdbd";
        case 2:
          return "#ffeb3b";
        case 3:
          return "#01d479";
        case 4:
          return "#00b0ff";
        case 5:
          return "#ff0000";
        case 6:
          return "#ffffff";
      }
    },
    getIconByStatus(status) {
      switch (status) {
        case 1:
          return this.$anm22.icons.getTasksIcon("tasksGrey");
        case 2:
          return this.$anm22.icons.getTasksIcon("tasksYellow");
        case 3:
          return this.$anm22.icons.getTasksIcon("tasksGreen");
        case 4:
          return this.$anm22.icons.getTasksIcon("tasksBlue");
        case 5:
          return this.$anm22.icons.getTasksIcon("tasksRed");
        case 6:
          return this.$anm22.icons.getTasksIcon("tasksWhite");
        default:
          return this.$anm22.icons.getTasksIcon("tasksBlack");
      }
    },
    changeWork(work) {
      this.workSelected = work !== "my" ? Number(work) : "my";
      this.$anm22.setCookie("anm22_work", work, 31536000);
      this.$store.dispatch("setWorkSelected", this.workSelected);
      if (this.$refs["works_div"]) {
        this.$refs["works_div"].scrollLeft = 0;
      }
      this.showWorkDialog = false;
      this.updateData(null, true);
    },
    getDefaultSortingFunctionGenerator(field, direction) {
      // Smart sorting
      if (field == "smart") {
        return (a, b) => {
          const aItem = a;
          const bItem = b;

          const aEndDate = this.$moment
            .unix(aItem.endDate)
            .utc()
            .format("YYYYMMDD");
          const bEndDate = this.$moment
            .unix(bItem.endDate)
            .utc()
            .format("YYYYMMDD");

          if (aEndDate > bEndDate) {
            return 1;
          }
          if (aEndDate < bEndDate) {
            return -1;
          }
          if (aItem.priorityScore < bItem.priorityScore) {
            return 1;
          }
          if (aItem.priorityScore > bItem.priorityScore) {
            return -1;
          }
          return 0;
        };
      }
      // Default sorting
      return (a, b) => {
        let aProp = a[field];
        let bProp = b[field];
        if (direction === "ASC") {
          if (aProp > bProp) {
            return 1;
          }
          if (aProp < bProp) {
            return -1;
          }
          return 0;
        } else {
          if (aProp > bProp) {
            return -1;
          }
          if (aProp < bProp) {
            return 1;
          }
          return 0;
        }
      };
    },
    /** ---------------------------------------------------------- */
    openBoardsMenu() {
      this.boardsMenuOpen = true;
      this.$anm22.setCookie("tk_p_bmo", this.boardsMenuOpen, 31536000);
    },
    closeBoardsMenu() {
      this.boardsMenuOpen = false;
      this.$anm22.setCookie("tk_p_bmo", this.boardsMenuOpen, 31536000);
    },
    changeBoardsMenuStatus() {
      this.boardsMenuOpen = !this.boardsMenuOpen;
      this.$anm22.setCookie("tk_p_bmo", this.boardsMenuOpen, 31536000);
    },
    changeView(view, componentInit) {
      if (typeof componentInit == "undefined") {
        componentInit = false;
      }
      if (view.startsWith("custom-")) {
        const viewId = view.substring(7);
        const customViewsData = this.availableCustomViews.filter(
          (v) => v.id == viewId
        );
        if (!customViewsData) {
          view = "cols";
          this.view = view;
          this.selectedBoard = this.boardsList.filter((b) => b.id == view)[0];
        } else {
          const customViewData = customViewsData[0];
          this.view = customViewData.type;
          this.selectedCustomView = customViewData;
          this.selectedBoard = this.boardsList.filter(
            (b) => b.customId == viewId
          )[0];
        }
      } else {
        this.view = view;
        this.selectedBoard = this.boardsList.filter((b) => b.id == view)[0];
      }
      this.$anm22.setCookie("tk_p_view", view, 31536000);
      this.showViewDialog = false;

      if (!componentInit && this.windowWidth <= 767) {
        this.closeBoardsMenu();
      }
    },
    filterProjects(newFilters) {
      /* Save filters in cookie */
      this.$anm22.setCookie(
        "tk-p-filters",
        JSON.stringify(
          newFilters.reduce((r, f) => {
            r.push([f.id, f.value]);
            return r;
          }, [])
        ),
        31536000
      );
      this.selectedFilters = newFilters;
      this.showFilterDialog = false;
    },
    filterSearchedProjects(newFilters) {
      /* Save searched filters in cookie */
      this.$anm22.setCookie(
        "tk-p-search-filters",
        JSON.stringify(
          newFilters.reduce((r, f) => {
            r.push([f.name, f.fn]);
            return r;
          }, [])
        ),
        31536000
      );
      this.searchFilters = newFilters;
    },
    getFilterIcon(filter) {
      switch (filter.id) {
        case "personal":
          return "userMaterial";
        case "fs":
          return "mailbox";
        case "job":
          return "monitor";
        case "category":
          return "folderMaterial";
        default:
          return "";
      }
    },
    /* 2-stage loading, first works to select right work filter */
    async loadData() {
      return this.$store
        .dispatch("works/load", this.$vlf("works"))
        .then(() => {
          this.workSelected = this.$store.getters["getWorkSelected"];
          this.workLoading = false; // Flag ricerca azienda terminata
          return Promise.all([
            this.$store.dispatch("projects/load", this.$vlf("projects")),
            this.$store.dispatch("employments/load", this.$vlf("employments")),
            this.$store.dispatch(
              "projectCategories/load",
              this.$vlf("projectCategories")
            ),
            this.$store.dispatch("users/load", this.$vlf("users")),
            this.$store.dispatch("licenses/load", this.$vlf("licenses")),
            this.$store.dispatch("tasks/load", this.$vlf("tasks")),
            this.$store.dispatch("tags/load", this.$vlf("tags")),
          ]);
        })
        .then(() => {
          this.$Progress.finish();
          this.loading = false;
          //Creazione progetto da app esterne
          if (
            this.$route.query.addProject &&
            this.$route.query.addProject == 1
          ) {
            //Creazione con customer preselezionato
            if (this.$route.query.customerParams) {
              let slugs = this.$route.query.customerParams;
              let slug = slugs.split(",");
              this.customerId = Number(slug[0]);
              this.customerWork = Number(slug[1]);
              //Controllo prima se ho i permessi sul work passato
              if (this.canAddByCustomerWork) {
                this.showAddDialog = true;
                this.$router.push("/");
              } else {
                this.customerId = null;
                this.customerWork = null;
                this.$router.push("/");
              }
            } else {
              if (this.canAdd) {
                this.showAddDialog = true;
                this.$router.push("/");
              }
            }
          }
        })
        .catch((error) => console.log(error));
    },
    async updateData(lastUpdateFrom, requireHistory, limit) {
      if (!this.offline) {
        try {
          const response = await this.$http.get(
            process.env.VUE_APP_DASHBOARD_BACK_DOMAIN +
              "/app/tasks/spa/controller/projects?w=" +
              this.workSelected +
              (requireHistory ? "&h=1" : "&h=0") +
              (lastUpdateFrom ? "&uaf=" + lastUpdateFrom : "") +
              (limit ? "&l=" + limit : "")
          );
          let tryReturn = this.$store.dispatch("projects/update", {
            vlf: this.$vlf("projects"),
            objs: response.data.projects,
            //cleanFilters: [],
          });
          if (requireHistory && response.data.uafNext) {
            this.updateData(response.data.uafNext, true, 300);
          }
          return tryReturn;
        } catch (e) {}
      }
    },
    changeFieldSorting() {
      this.$anm22.setCookie("tk_p_col", this.orderingField, 31536000);
    },
    changeDirectionSorting() {
      this.$anm22.setCookie("tk_p_dir", this.orderingDir, 31536000);
    },
    // async syncData() {
    //   console.log('syncing!');
    //   const vlf = this.$vlf('syncUpdates');
    //   const reqData = [];
    //   let response = null;
    //   try {
    //     await vlf.iterate((v, k, i) => {
    //       reqData.push(v);
    //     });
    //     if(reqData.length > 0) {
    //       let formData = new FormData();
    //       reqData.forEach(d => {
    //         /* Custom per i file delle spese */
    //         if(d.class === 'WorldOutgo' && d.obj.images.length > 0) {
    //           d.obj.images.forEach(img => {
    //             if(typeof(img) !== String) {
    //               formData.append('files['+ d.syncId +'][]', img.file);
    //             }
    //           });
    //           /* Non dobbiamo inviare il dataURL o il file qui */
    //           delete(d.obj.images);
    //         }
    //         Object.keys(d.obj).forEach(key => {
    //           if(d.obj[key] === "") {
    //             delete(d.obj[key]);
    //           }
    //         });
    //         formData.append('data[]', JSON.stringify(d));
    //       })
    //       response = await this.$http.post('sync', formData);
    //     } else {
    //       throw new Error('No data to sync!');
    //     }
    //     if(response.data) {
    //       response.data.success.forEach(d => {
    //         // vlf.removeItem(d.syncId);
    //         vlf.removeItem(d.class + d.syncId);
    //         if(d.old.type === 'new' || d.old.type === 'edit'){
    //           this.$store.dispatch(d.table + '/update', {
    //             vlf: this.$vlf(d.table), objs: [d.obj]
    //           });
    //           if(d.old.type === 'new') {
    //             this.$store.dispatch(d.table + '/delete', {
    //               vlf: this.$vlf(d.table), obj: d.old.obj
    //             });
    //           }
    //         }
    //       });
    //     } else {
    //       throw new Error('Empty response!');
    //     }
    //   } catch(e) {
    //     console.log(e.message);
    //   }
    // }
  },
  components: {
    ProjectsList,
    ProjectsKanban,
    ProjectsGantt,
    ProjectsTimeline,
    ProjectsJobs,
    ProjectsCustomKanban,
    // ProjectBar,
    ProjectAddModal,
    ProjectTemplates,
    "vue-simple-spinner": Spinner,
    Anm22DialogFilter,
    Anm22SearchbarFilter,
    WorldHelpLabel,
  },
  async created() {
    if (this.$anm22.getCookie("tk-p-filters") !== "") {
      const cookieFilters = JSON.parse(
        this.$anm22.getCookie("tk-p-filters")
      ).map((f) => {
        return { id: f[0], value: f[1] };
      });
      if (!cookieFilters.find((f) => !f.id)) {
        this.selectedFilters = cookieFilters;
      } else {
        this.filterProjects(this.selectedFilters);
      }
    }
    if (this.$anm22.getCookie("tk-p-search-filters") !== "") {
      const cookieSearchFilters = JSON.parse(
        this.$anm22.getCookie("tk-p-search-filters")
      ).map((f) => {
        return { name: f[0], fn: f[1] };
      });
      if (!cookieSearchFilters.find((f) => !f.name)) {
        this.searchFilters = cookieSearchFilters;
      } else {
        this.filterSearchedProjects(this.searchFilters);
      }
    }
    this.loading = true;

    // Load data from local DB
    await this.loadData();

    // Load the selected view by the cookie
    if (this.$anm22.getCookie("tk_p_view") !== "") {
      this.changeView(this.$anm22.getCookie("tk_p_view"), true);
    }

    this.$http
      .get(
        process.env.VUE_APP_DASHBOARD_BACK_DOMAIN +
          "/app/tasks/spa/controller/projects?w=" +
          this.workSelected +
          "&h=1"
      )
      .then((response) => {
        if (response.data) {
          Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects,
              //cleanFilters: [],
            }),
            this.$store.dispatch("employments/update", {
              vlf: this.$vlf("employments"),
              objs: response.data.employments,
              cleanFilters: [],
            }),
            this.$store.dispatch("projectCategories/update", {
              vlf: this.$vlf("projectsCategories"),
              objs: response.data.projectCategories,
              cleanFilters: [],
            }),
            this.$store.dispatch("works/update", {
              vlf: this.$vlf("works"),
              objs: response.data.works,
              cleanFilters: [],
            }),
            this.$store.dispatch("users/update", {
              vlf: this.$vlf("users"),
              objs: response.data.users,
              cleanFilters: [],
            }),
            this.$store.dispatch("licenses/update", {
              vlf: this.$vlf("licenses"),
              objs: response.data.licenses,
              cleanFilters: [],
            }),
            this.$store.dispatch("tags/update", {
              vlf: this.$vlf("tags"),
              objs: response.data.tags,
              cleanFilters: [],
            }),
          ])
            .then(() => {
              this.$store.dispatch("offline/sync", {
                _vue: this,
                blocking: true,
              });
            })
            .catch((error) => console.log(error));

          if (response.data.uafNext) {
            this.updateData(response.data.uafNext, true, 300);
          }
        } else {
          /* Valutare meccanismo automatico per la cancellazione del db locale in caso di jwt non riconosciuto */
          Promise.all([
            this.$vlf("projects").clear(),
            this.$vlf("employments").clear(),
            this.$vlf("works").clear(),
            this.$vlf("users").clear(),
            this.$vlf("licenses").clear(),
            this.$vlf("projectCategories").clear(),
          ]).then((result) => {
            this.$router.push("/");
          });
        }
      })
      .catch((error) => console.log(error));
  },
  mounted() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", {
      hintFn: this.searchFn,
    });
    this.$nextTick(() => {
      this.updateInterval = setInterval(() => {
        this.updateData();
      }, 30000);
    });
  },
  destroyed() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", null);
    clearInterval(this.updateInterval);
  },
};
</script>

<style lang="scss" scoped>
.filter-button {
  background-repeat: no-repeat;
  background-position: 9px 7px;
  background-size: 20px 20px;
  padding-left: 32px;
}
.change-label {
  padding: 6px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #666;
  color: #666;
  margin: 0 0 0 auto;
  border-radius: 4px;
}
.change-label .name {
  font-size: 15px;
  color: #666;
  display: inline-block;
  vertical-align: middle;
}
.change-label .img {
  display: inline-block;
  vertical-align: middle;
  margin-left: 3px;
}
@media screen and (max-width: 992px) {
  .change-label .name {
    display: none;
  }
  .change-label .img {
    margin: auto;
  }
}
.views-list {
  text-align: center;

  .item {
    text-align: center;
    display: inline-block;
    vertical-align: top;
    width: 150px;
    margin: 5px;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px 0 15px 0;

    img {
      display: inline-block;
      height: 60px;
      opacity: 0.6;
    }
    div {
      text-align: center;
      display: block;
      font-size: 16px;
    }
  }
  .item:hover,
  .item.selected {
    background: #eee;
  }
}
.select-works-list {
  .item {
    padding: 8px;
    border-radius: 10px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }

    img {
      display: inline-block;
      vertical-align: middle;
    }

    .lbl {
      font-size: 16px;
      display: inline-block;
      max-width: calc(100% - 45px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
    }
  }
}

.open-board-menu-btn {
  border-radius: 15px;
  display: flex;
  align-items: center;
  padding: 5px;
  margin-left: 5px;
  cursor: pointer;

  .open-board-menu-btn-label {
    display: none;
    padding: 0 5px;
  }

  img {
    opacity: 0.6;
  }

  &:hover {
    background-color: #eee;

    .open-board-menu-btn-label {
      display: block;
    }
  }
}

@media (max-width: 767px) {
  .open-board-menu-btn {
    &:hover {
      .open-board-menu-btn-label {
        display: none;
      }
    }
  }
}

.sub-menu-nav {
  position: relative;
  .sub-menu-close-btn {
    position: absolute;
    top: 24px;
    right: 0px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    opacity: 0.6;

    &:hover {
      opacity: 1;
    }

    &.mobile {
      display: none;
    }
  }
}
.sub-menu-col {
  border-right: 1px solid #eee;
  position: relative;
}
.sub-menu-ul {
  width: 100%;
  padding: 0;
  .title {
    color: #999;
    font-weight: bold;
    text-transform: uppercase;
    padding: 7px 0;
  }
}
.menu-divider {
  border-top: 1px solid #ddd;
  margin: 8px 0;
}
.sub-menu-li {
  box-sizing: border-box;
  padding: 2px 0 2px 0;
  min-height: 35px;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
  border-radius: 6px;
  padding: 5px;
  margin: 1px;

  .item-icon {
    height: 20px !important;
    margin-right: 20px;
    opacity: 0.6;
  }

  &.selected {
    background-color: rgba(0, 0, 0, 0.05);
    .item-icon {
      opacity: 1;
    }
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    .item-icon {
      opacity: 1;
    }
  }
  &.disabled {
    opacity: 0.4;
    cursor: default;

    &:hover {
      background: none;
      .item-icon {
        opacity: 0.6;
      }
    }
  }
  &.inactive {
    opacity: 0.3;
    pointer-events: none;
  }
  &.not-clickable {
    opacity: 1;
    cursor: default;

    &:hover {
      background: none;
      .item-icon {
        opacity: 0.6;
      }
    }
  }

  & > div {
    font-size: 14px;
    font-weight: 500;
  }

  &.main-title {
    padding: 5px 0;
    & > div {
      font-size: 20px;
      font-weight: 400;
    }
  }
}
@media (max-width: 767px) {
  .sub-menu-col {
    border: none;
  }
  .sub-menu-nav {
    padding: unset;

    .sub-menu-close-btn {
      top: 33px;

      &.desktop {
        display: none;
      }
      &.mobile {
        display: block;
      }
    }
  }
  .sub-menu-ul {
    padding: 10px 0 0;
  }
  .sub-menu-list {
    position: absolute;
    background: #fff;
    z-index: 100;
    border: 1px solid #ccc;
    border-top: none;
  }
}
</style>

<style lang="scss">
@media print {
  body, html {
    background-color: #fff !important;
  }
  .anm22-task-headmenu,
  .anm22_template_anm22it_2014_headBar,
  #anm22_world_menu_small,
  .open-icon-div {
    display: none !important;
  }
  .com-anm22-app-outer-wrapper {
    padding: 0 !important;
  }
  .com-anm22-app-scrolling-panel {
    height: auto !important;
  }
  .projects-view-body {
    display: block !important;
  }
}
</style>
